import { render, staticRenderFns } from "./BundlePurchaseFkuList.vue?vue&type=template&id=393cef30&"
import script from "./BundlePurchaseFkuList.vue?vue&type=script&lang=ts&"
export * from "./BundlePurchaseFkuList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports